<script>
  import {onMount} from "svelte";
  import gsap from 'gsap';
  import MotionPathPlugin from "gsap/MotionPathPlugin";

  gsap.registerPlugin(MotionPathPlugin);

  export let radius = 600;
  export let orbitalPeriod = 1;
  export let planetScale = ((orbitalPeriod + 1) * 0.125) * 0.5;

  const duration = 35 * (orbitalPeriod + 1) * 0.5 + (Math.random() * 0.25);
  const transformOrigin = `50% 50%`;

  let holster;
  let planet;

  const planetImageSize = 45;
  const timeline= gsap.timeline();

  onMount(() => {
    timeline.to(holster, {
      motionPath: '#circle',
      duration,
      ease: 'linear',
      reversed: true,
      repeat: -1,
    })
      .time(Math.random() * duration)
  });
</script>

<svg height="800px" viewBox={`0 0 ${radius * 2} ${radius * 2}`} overflow="visible">
    <g class="planet-and-orbit">
        <path d={`
            M 0, ${radius}
            a ${radius},${radius} 0 1,0 ${radius * 2},0
            a ${radius},${radius} 0 1,0 ${- radius  * 2},0
        `} class="orbit" id="circle" />

        <g bind:this={holster}>
            <g class="planet-container">
                <g bind:this={planet} transform={`scale(${planetScale} ${planetScale + planetScale * 4.5 })`}>
                    <image xlink:href="images/small-planet.png" class="planet"/>
                </g>
            </g>
        </g>
    </g>
</svg>

<style>
    .orbit {
        stroke-width: 2;
        stroke-dasharray: 10, 10;
        fill: none;
        stroke: white;
        opacity: 0.5;
    }

    .planet-and-orbit {
        transform: rotate3d(1, 0, 0, 80deg);
    }

    .planet {
        transform: translate(-50%, -50%);
        transform-box: fill-box;
        opacity: 0.75;
    }
</style>